import React from 'react';
import '../App.css';
import { useState } from "react";
import Swal from 'sweetalert2';
import { db } from '../firebase-config';
import { collection, addDoc } from "firebase/firestore";
import ctg from '../ctg.json'

function CrearProducts(){


    const [imagen, setImagen] = useState([]);
    const [imagenes, setImagenes] = useState([]);
    
    const [selectedFile, setSelectedFile] = useState(null);
    
    const [newTitle, setNewTitle] = useState('');
    const [newCategory, setNewCategory] = useState('');
    const [newDesc, setNewDesc] = useState('');
    const [newPrice, setNewPrice] = useState(0);
    const [newCantidad, setNewCantidad] = useState(0);

    const agregarImagen=(img)=>{
        if(img.length === 0){
            Swal.fire(
                'Imagen',
                'Debe insertar una imagen!',
                'info'
            )
        }else{
           setImagenes([img, ...imagenes])
           setImagen('');
           document.getElementById('url-img').value=''
        }
    }

   const eliminarImagen=(i)=>{
        // const updatedImages = imagenes.filter(item => item !== i);
        // setImagenes(updatedImages);
        const updatedImages = [...imagenes];
        updatedImages.splice(i, 1);
        setImagenes(updatedImages);
   }

    const handleFileSelect = (event) => {
        setSelectedFile(event.target.files[0]);
    
        // Crear un objeto FileReader
        const reader = new FileReader();
    
        // Definir la función que se llamará cuando se complete la lectura del archivo
        reader.onload = (e) => {
          // Obtener el contenido del archivo en Base64 y almacenarlo en el estado
          setImagen(e.target.result);
        };
    
        // Leer el archivo como una URL de datos en formato Base64
        reader.readAsDataURL(event.target.files[0]);

    };   

    const envioFormulario=()=>{

        if(newTitle === "" || newDesc === "" || newPrice === 0 || imagenes.length === 0){
            Swal.fire(
                'Oops...',
                'Debe rellenar todos los campos o agregar imagen!',
                'error'
            )
        }
        else{
            Swal.fire(
                'Gob Job',
                'Agregado Correctamente!',
                'success'
            )
            createProducts()
            setTimeout(() => window.location.reload(), 1500)
        }
    }

    const createProducts = () =>{
        const productsCollectionRef = collection(db, "products");
        addDoc(productsCollectionRef, {category: newCategory, description: newDesc, image: imagenes, price: Number(newPrice), quantity: Number(newCantidad), title: newTitle})
    }

    return (
        <>
            <div className="container-inventario">

                <section className="general">

                    <form method="" className="form-container">
                        <div className="checkout-form">

                            <div className="input-line">
                                <label for="">Titulo</label>
                                <input type="text" name="" id="" placeholder="" required onChange={(e)=> setNewTitle(e.target.value)}/>
                            </div>

                            <div className="input-line">
                                <label for="name">Categoria</label>
                                {/* <input type="text" name="categoria" id="categoria" placeholder="" required onChange={(e)=> setNewCategory(e.target.value)}/> */}
                                <select name="" id="" onChange={(e)=> setNewCategory(e.target.value)}>
                                    {ctg.map((c)=>{
                                        return(
                                           <option value={c.link}>{c.nombre}</option> 
                                        )
                                    })}
                                </select>
                            </div>

                            <div className="input-container">

                                <div className="input-line">
                                    <label for="precio">Precio RD$</label>
                                    <input type="number" placeholder="" required onChange={(e)=> setNewPrice(e.target.value)}/>
                                </div>

                                <div className="input-line-cantidad">
                                    <label for="cantidad">Cantidad</label>
                                    <input type="number" placeholder="" required min={1} max={10} onChange={(e)=> setNewCantidad(e.target.value)}/>
                                </div>

                            </div>
                            

                            <div className="input-line">
                                <label for="name">Descripcion</label>
                                <textarea type="text" name="name" id="name" placeholder="" required onChange={(e)=> setNewDesc(e.target.value)}/>
                            </div>

                            <div className='imagenes-agregadas'>

                                {imagenes.map((i,index)=>{
                                    return(
                                        <article>
                                            <i class="fa fa-window-close" onClick={()=>eliminarImagen(index)}></i>
                                            <img src={i} alt="" width="120px" height="140px"/>
                                        </article>
                                    )
                                })} 

                            </div>

                            <input onClick={()=>envioFormulario()} className='continuar-checkout' type="button" value="Agregar Producto"></input>

                        </div>
                    </form>

                </section>

                <section className="images-inventario">

                    <img className='img-p' src={imagen} width="100%" alt="" />

                    <div class="searchbar">
                        <div class="searchbar-wrapper">
                            <div class="searchbar-left">
                                <div class="search-icon-wrapper">
                                    <span class="search-icon searchbar-icon">
                                        <img width='40px' height='40px' src={require('../assets/images/up-arrow.png')} alt="" />
                                        <label className="file-input-label">
                                            <input
                                            type="file"
                                            className="file-input"
                                            accept=".jpg,.png,jpeg"
                                            onChange={handleFileSelect}
                                            />
                                        </label>
                                    </span>
                                </div>
                            </div>

                            <div class="searchbar-center">
                                <div class="searchbar-input-spacer"></div>

                                <input type="url" class="searchbar-input" id="url-img" placeholder="Image (URL)" onChange={e=> setImagen(e.target.value)}/>
                            </div>

                            <div class="searchbar-right">
                                <img onClick={()=>agregarImagen(imagen)} width='37px' src={require('../assets/images/image-add.png')} alt="" />
                            </div>
                        </div>
                    </div>

                </section>
                
            </div>
        </>
    )
}

export default CrearProducts
